import { jwtDecode } from "jwt-decode";

import { jsPDF } from "jspdf";
import "jspdf-autotable";
import dayjs from "dayjs";


export function storeToken(token) {
  const decodedToken = jwtDecode(token);
  const expirationTime = decodedToken.exp * 1000;
  localStorage.setItem("token", token);
  localStorage.setItem("tokenExpiration", expirationTime);
}

export const convertDateFormat = (dateStr) => {
  const date = new Date(dateStr);
  const formattedDate = date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  const finalFormattedDateTime = `${formattedDate} - ${formattedTime}`;
  return finalFormattedDateTime;
};

export function formatDateTime(dateTime) {
  const date = new Date(dateTime);

  const options = { month: "short", day: "2-digit" };
  const formattedDate = date.toLocaleDateString("en-US", options);

  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");

  const amPm = hours >= 12 ? "pm" : "am";

  const formattedTime = `${hours % 12 || 12}:${minutes} ${amPm}`;

  return `${formattedDate} @ ${formattedTime}`;
}

export function formatDateandTime(isoString) {
  const date = new Date(isoString);

  const formattedDate = `${String(date.getMonth() + 1).padStart(
    2,
    "0"
  )}/${String(date.getDate()).padStart(2, "0")}/${date.getFullYear()}`;

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? String(hours).padStart(2, "0") : "12";

  const formattedTime = `${hours}:${minutes} ${ampm}`;

  return {
    date: formattedDate,
    time: formattedTime,
  };
}

export function formatDateandTime1(isoString) {
  const date = new Date(isoString);
  const formattedDate = `${String(date.getUTCDate()).padStart(2, "0")}/${String(
    date.getUTCMonth() + 1
  ).padStart(2, "0")}/${date.getUTCFullYear()}`;
  let hours = date.getUTCHours();
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? String(hours).padStart(2, "0") : "12";
  const formattedTime = `${hours}:${minutes} ${ampm}`;
  return { date: formattedDate, time: formattedTime };
}

export function getMonthNumbers(selectedMonths) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return selectedMonths
    .map((month) => {
      const monthIndex = months.indexOf(month);
      return monthIndex !== -1 ? monthIndex + 1 : null; // Returns null if month is not found
    })
    .filter((number) => number !== null); // Filter out any null values
}

 

export function addOneHourFromPrevTime(time) {
  // Parse the input time
  if (!time) return;
  let [hour, minute] = time.split(":");
  let period = minute.slice(-2); // Get AM/PM
  minute = minute.slice(0, 2); // Get minutes
  hour = parseInt(hour, 10);
  minute = parseInt(minute, 10);

  // Add one hour
  hour += 1;

  // Adjust for AM/PM
  if (hour === 12 && period === "AM") {
    // 12 AM becomes 1 AM
    period = "AM";
  } else if (hour === 12 && period === "PM") {
    // 12 PM stays 12 PM
    period = "PM";
  } else if (hour > 12) {
    // Convert to 12-hour format
    hour -= 12;
    period = period === "AM" ? "PM" : "AM";
  }

  // Ensure hour is two digits
  if (hour === 0) {
    hour = 12; // Midnight case
  }

  const newTime = `${String(hour).padStart(2, "0")}:${String(minute).padStart(
    2,
    "0"
  )} ${period}`;
  console.log(newTime, ">>>FROM");
  return newTime;
}

export function maskHalfText(text) {
  const halfLength = Math.ceil(text?.length / 2);
  const maskedPart = "x".repeat(halfLength);
  const unmaskedPart = text?.slice(0, -halfLength);
  return unmaskedPart + maskedPart;
}

export function maskText(text) {
  return "x".repeat(text?.length);
} 

export function exportToPDF(data) {
  const doc = new jsPDF();

  if (data && (data.createdData || data.updatedData)) {
     
    // Prepare the data for the first table (Newly Created Data)
    const createdTableColumn = ["ID", "Name", "Email"];
    const createdTableRows = data?.createdData?.data?.map((user) => [
      user.id,
      `${user.first_name} ${user.last_name}`,
      user.email,
    ]) || []; // Default to empty array if no data

    // Add title to the PDF
    doc.setFontSize(20);
    doc.text("Metrics", 14, 15);

    // Section for Newly Created Data
    doc.setFontSize(15);
    doc.text("Newly Created Data", 14, 30);
    doc.setFontSize(10);
    doc.text(`Student Added Count - ${data?.createdData?.count || 0}`, 14, 40);

    if (createdTableRows.length > 0) {
      // Create the first table
      doc.autoTable({
        head: [createdTableColumn],
        body: createdTableRows,
        startY: 50,
        theme: "grid",
        styles: {
          fontSize: 10,
          cellPadding: 2,
          overflow: "linebreak",
        },
        columnStyles: {
          0: { cellWidth: 20 }, // ID column
          1: { cellWidth: 50 }, // Name column
          2: { cellWidth: 90 }, // Email column
        },
        headStyles: {
          fillColor: [66, 66, 66],
          textColor: 255,
          fontSize: 11,
          fontStyle: "bold",
        },
      });
    } else {
      doc.text("No Data Found", 14, 50);
    }

    // Check the Y-position after the first table
    let nextSectionY = doc.autoTable.previous.finalY + 20 || 70; // Suggested Y position for next section

    // If the next section would be too low on the page, add a new page
    if (nextSectionY + 30 > doc.internal.pageSize.height) {
      doc.addPage();
      nextSectionY = 20; // Reset Y position for the new page
    }

    // Section for Newly Updated Data
    doc.setFontSize(15);
    doc.text("Newly Updated Data", 14, nextSectionY);
    doc.setFontSize(10);
    doc.text(
      `Student Updated Count - ${data?.updatedData?.count || 0}`,
      14,
      nextSectionY + 10
    );

    // Prepare the data for the second table (Newly Updated Data)
    const updatedTableColumn = ["ID", "Name", "Email"];
    const updatedTableRows = data?.updatedData?.data?.map((user) => [
      user.id,
      `${user.first_name} ${user.last_name}`,
      user.email,
    ]) || []; // Default to empty array if no data

    if (updatedTableRows.length > 0) {
      // Create the second table
      doc.autoTable({
        head: [updatedTableColumn],
        body: updatedTableRows,
        startY: nextSectionY + 20,
        theme: "grid",
        styles: {
          fontSize: 10,
          cellPadding: 2,
          overflow: "linebreak",
        },
        columnStyles: {
          0: { cellWidth: 20 }, // ID column
          1: { cellWidth: 50 }, // Name column
          2: { cellWidth: 90 }, // Email column
        },
        headStyles: {
          fillColor: [66, 66, 66],
          textColor: 255,
          fontSize: 11,
          fontStyle: "bold",
        },
      });
    } else {
      doc.text("No Data Found", 14, nextSectionY + 20);
    }
  } else {
    const message = "No Data Found";
    const messageWidth = doc.getStringUnitWidth(message) * doc.internal.getFontSize() / doc.internal.scaleFactor;
    const x = (doc.internal.pageSize.width - messageWidth) / 2; // Centering the text
    doc.text(message, x, 20);
  }

  // Save the PDF
  doc.save("Metrics.pdf");
}




export const roundUpToNextHour = () => {
  const currentTime = dayjs();
  return currentTime.minute() === 0 ? currentTime : currentTime.add(1, "hour").startOf("hour");
};

export const roundToNext15Minutes = () => {
  const now = dayjs();
  const minutes = now.minute();
  const roundedMinutes = Math.ceil(minutes / 15) * 15; // Round up to the nearest 15
  const roundedTime = now.minute(roundedMinutes).second(0);

  // If minutes are exactly 60, go to the next hour and reset minutes to 0
  return roundedMinutes === 60 ? roundedTime.add(1, 'hour').minute(0) : roundedTime;
};

// Function to round up to the next interval
const roundUpToNextInterval = (time, interval) => {
  const remainder = interval - (time.minute() % interval);
  return remainder === interval ? time : time.add(remainder, "minute");
};

// Generate time options based on selected date
export const generateTimeOptions = (date, interval) => {
  const options = [];
  const isToday = date.isSame(dayjs(), "day");
  let startTime;

  // If the selected date is today, start after the current time
  if (isToday) {
    startTime = roundUpToNextInterval(dayjs(), interval);
  } else {
    // If the selected date is in the future, start from midnight
    startTime = dayjs(date).startOf("day");
  }

  // Generate times at the specified interval until the end of the day
  while (startTime.isBefore(dayjs(date).endOf("day"))) {
    options.push(startTime.format("h:mm A"));
    startTime = startTime.add(interval, "minute");
  }

  return options;
};

export const generateTimeOptionsAfter = (start, interval) => {
  const options = [];
  let currentTime = start.add(interval, "minute"); // Start strictly after the selected "From Time"
  while (currentTime.isBefore(dayjs().endOf("day"))) {
    options.push(currentTime.format("h:mm A"));
    currentTime = currentTime.add(interval, "minute");
  }
  return options;
};